import { Application, Catalogue } from '../../common';
import { DeliveryDetails } from '../types/delivery-details';
import { getSolutionsDeliveryBreakdown } from './delivery-helpers';

export function getDeliveryDetails(
  application: Application,
  catalogue: Catalogue,
): DeliveryDetails {
  const { solutionsWithoutAddresses } = getSolutionsDeliveryBreakdown(application, catalogue, true);

  const deliveryDetails: DeliveryDetails = {};

  if (solutionsWithoutAddresses.length > 0) {
    deliveryDetails.defaultAddress = {
      solutions: solutionsWithoutAddresses,
      address: application.contact?.businessAddress || {},
      receiverDetails: {
        managerName: `${application.contact?.name} ${application.contact?.surname}`,
        idNumber: application.contact?.idNumber,
        phone: application.contact?.mobileNumber,
        workPhone: application.contact?.mobileNumber,
        cellPhone: application.contact?.mobileNumber,
        tradingAs:
          application.businessDetails?.companyName || application.businessDetails?.registeredName,
      },
    };
  }

  const deliveries = application?.opportunity?.deliveries || [];

  if (deliveries.length > 0) {
    deliveryDetails.customAddresses = deliveries;
  }

  return deliveryDetails;
}
